<template>
  <label class="reseller-radio-button">
    <input
      type="radio"
      class="reseller-radio-button__origin"
      v-model="model"
      :value="label"
      :name="name"
      @change="handleChange"
    />
    <span class="reseller-radio-button__inner" @keydown.stop>
      <slot></slot>
      <template v-if="!$slots.default">{{ label }}</template>
    </span>
  </label>
  <!-- <label class="reseller-radio-button">
    <input type="radio" class="reseller-radio-button__origin" name="gender" />
    <span class="reseller-radio-button__inner">여자</span>
  </label> -->
</template>

<script>
export default {
  props: {
    label: {},
    name: String,
    value: String
  },

  computed: {
    model: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },

  methods: {
    handleChange(evt) {
      this.$emit('click', evt);
    }
  }
};
</script>

<style></style>
